import { useMemo } from 'react';

import { ACTION_OBJECT_TYPES } from 'actions/useActionsLibrary';

import { TabTableContainer } from 'components/layout/AppLayout/AppLayout.styled';
import DynamicList from 'components/list/DynamicList';
import { FilterType, ListComponents } from 'components/list/DynamicListFilterUtils';

import { CUSTOMER_SERVICE, ENUMS } from 'services/consts';

import { DYNAMICLISTS } from 'utils/constants';

const CustomerServiceFeedbacksList = () => {
	const defaultSort = useMemo(() => [{ id: 'createdAt', desc: true }], []);

	const columns = useMemo(
		() => [
			{
				Header: 'ID',
				accessor: 'ID',
				filterType: FilterType.number,
				width: 70,
				show: false,
				showCopyButton: true
			},
			{
				Header: 'orderID',
				accessor: 'orderID',
				filterType: FilterType.string,
				width: 100,
				showOnMobile: true,
				showOnMap: true,
				showCopyButton: true
			},
			{
				Header: 'orderDate',
				accessor: 'createdDate',
				filterType: FilterType.date,
				width: 100,
				renderCell: ListComponents.DATETIME
			},
			{
				Header: 'status',
				accessor: 'status',
				renderCell: ListComponents.STATUS,
				filterType: FilterType.enumMulti,
				enumName: ENUMS.ALL_STATUSES,
				showOnMobile: true,
				width: 200
			},
			{
				Header: 'salesChannel',
				accessor: 'salesChannelName',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.SALES_CHANNEL_ACTIVE,
				width: 100,
				renderCell: ListComponents.SALES_CHANNEL_LOGO,
				show: false,
				roleName: 'SalesChannelModule'
			},
			{
				Header: 'pickupLocation',
				accessor: 'pickupLocation',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.PICKUP_LOCATION,
				width: 100,
				show: false
			},
			{
				Header: 'brandName',
				accessor: 'storeName',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.BRAND_NAME,
				width: 100,
				renderCell: ListComponents.BRAND_LOGO,
				roleName: 'BrandingModule',
				show: false
			},
			{ Header: 'customerName', accessor: 'name', filterType: FilterType.string, width: 100 },
			{
				Header: 'customerEmail',
				accessor: 'email',
				filterType: FilterType.string,
				width: 100
			},
			{
				Header: 'customerPhone',
				accessor: 'phone',
				filterType: FilterType.string,
				width: 100,
				renderCell: ListComponents.PHONE
			},
			{ Header: 'customerAddress', accessor: 'address', filterType: FilterType.string, width: 130 },
			{
				Header: 'destinationCountry',
				accessor: 'countryName',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.COUNTRIES,
				filterPrefix: 'country.',
				renderCell: ListComponents.COUNTRY,
				width: 100,
				show: false
			},
			{
				Header: 'destinationCity',
				accessor: 'cityName',
				filterType: FilterType.multiSelection,
				width: 100,
				show: false
			},
			{
				Header: 'grandTotal',
				accessor: 'grandTotal',
				filterType: FilterType.float,
				width: 120,
				renderCell: ListComponents.CURRENCY,
				showOnMap: true
			},
			{
				Header: 'packageCount',
				accessor: 'packageCount',
				filterType: FilterType.number,
				width: 50,
				show: false
			},
			{
				Header: 'weight',
				accessor: 'weight',
				filterType: FilterType.number,
				width: 50,
				show: false
			},
			{
				Header: 'packageSize',
				accessor: 'maxPackageSize',
				filterType: FilterType.string,
				show: false
			},
			{
				Header: 'couponCode',
				accessor: 'couponCode',
				filterType: FilterType.string,
				roleName: 'EnterprisePackage',
				show: false
			},
			{ Header: 'district', accessor: 'district', filterType: FilterType.string, width: 100, show: false },
			{ Header: 'state', accessor: 'state', filterType: FilterType.string, width: 100, show: false },
			{ Header: 'region', accessor: 'region', filterType: FilterType.string, width: 100, show: false },
			{
				Header: 'areaName',
				accessor: 'areaName',
				filterType: FilterType.string,
				show: false,
				roleName: 'OMSModule'
			},

			{
				Header: 'paymentMethod',
				accessor: 'paymentMethod',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.PAYMENT_METHOD_FOR_LIST,
				width: 100,
				showOnMap: true,
				show: false
			},
			{
				Header: 'totalDue',
				accessor: 'totalDue',
				filterType: FilterType.float,
				width: 90,
				renderCell: ListComponents.CURRENCY,
				show: false
			},
			{
				Header: 'lastComment',
				accessor: 'lastComment',
				filterType: FilterType.string,
				renderCell: ListComponents.LAST_COMMENT,
				width: 100,
				show: false,
				roleName: 'EnterprisePackage'
			},
			{ Header: 'comments', accessor: 'comments', filterType: FilterType.string, width: 120, show: false },
			{
				Header: 'deliverySlot',
				accessor: 'deliverySlot',
				filterType: FilterType.string,
				width: 100,
				show: false,
				roleName: 'EnterprisePackage'
			},
			{
				Header: 'deliverySlotDate',
				accessor: 'deliverySlotDate',
				filterType: FilterType.date,
				renderCell: ListComponents.DATE,
				width: 100,
				show: false,
				roleName: 'EnterprisePackage'
			},
			{
				Header: 'shipmentNumber',
				accessor: 'shipmentNumber',
				filterType: FilterType.string,
				width: 100,
				renderCell: ListComponents.TRACKING_URL,
				show: false
			},
			{
				Header: 'deliveryName',
				accessor: 'deliveryName',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.DELIVERY_COMPANIES_USED,
				width: 90,
				renderCell: ListComponents.DC_LOGO,
				show: false
			},

			{
				Header: 'shippingCost',
				accessor: 'OTOdeliveryFee',
				filterType: FilterType.number,
				width: 100,
				renderCell: ListComponents.CURRENCY,
				renderCellProps: {
					currency: 'undefined'
				},
				show: false
			},
			{
				Header: 'driverPhone',
				accessor: 'driverPhone',
				filterType: FilterType.string,
				width: 100,
				renderCell: ListComponents.PHONE,
				roleName: 'OTOFlexModule',
				show: false
			},
			{
				Header: 'driverName',
				accessor: 'driverName',
				filterType: FilterType.string,
				width: 100,
				roleName: 'OTOFlexModule',
				show: false
			},
			{
				Header: 'onHoldComment',
				accessor: 'onHoldComment',
				filterType: FilterType.string,
				width: 105,
				show: false
			},
			{
				Header: 'onHoldReason',
				accessor: 'onHoldReason',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.ON_HOLD_REASON_CONFIG,
				show: false
			},
			{
				Header: 'cancelComment',
				accessor: 'cancelComment',
				filterType: FilterType.string,
				width: 90,
				show: false
			},
			{
				Header: 'cancelReason',
				accessor: 'cancelReason',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.CANCEL_REASON_CONFIG,
				width: 90,
				show: false
			},
			{
				Header: 'shipmentCreationDate',
				accessor: 'shipmentCreationDate',
				filterType: FilterType.date,
				showOnMobile: true,
				show: false,
				renderCell: ListComponents.DATETIME
			},
			{
				Header: 'rating',
				accessor: 'rating',
				filterType: FilterType.number,
				showOnMobile: true
			},
			{
				Header: 'shipmentRating',
				accessor: 'shipmentRating',
				filterType: FilterType.number
			},
			{
				Header: 'rateComment',
				accessor: 'rateComment',
				filterType: FilterType.string,
				showOnMobile: true
			},
			{
				Header: 'ratingFile',
				accessor: 'ratingFile',
				filterType: FilterType.string,
				renderCell: ListComponents.DOWNLOAD_FILE
			},
			{
				Header: 'ref1',
				accessor: 'ref1',
				filterType: FilterType.string,
				width: 90,
				show: false,
				roleName: '/column/ref1',
				renderCell: ListComponents.URL
			},
			{
				Header: 'ref2',
				accessor: 'ref2',
				filterType: FilterType.string,
				width: 90,
				show: false,
				roleName: '/column/ref2',
				renderCell: ListComponents.URL
			},
			{
				Header: 'ref3',
				accessor: 'ref3',
				filterType: FilterType.string,
				width: 90,
				show: false,
				roleName: '/column/ref3',
				renderCell: ListComponents.URL
			}
		],
		[]
	);

	return (
		<TabTableContainer>
			<DynamicList
				id={DYNAMICLISTS.CUSTOMER_FEEDBACKS}
				columns={columns}
				fetchUrl={CUSTOMER_SERVICE.GET_CUSTOMER_FEEDBACKS}
				defaultSort={defaultSort}
				actionObjectType={ACTION_OBJECT_TYPES.ORDER}
				exportName="customerFeedbacks"
			/>
		</TabTableContainer>
	);
};

export default CustomerServiceFeedbacksList;
